import { render } from "./ApprovalBastImkpModal.vue?vue&type=template&id=079b3b9c"
import script from "./ApprovalBastImkpModal.vue?vue&type=script&lang=js"
export * from "./ApprovalBastImkpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__